export default __webpack_public_path__ + "static/media/driver_big.e8deadd6.svg";